// TODO: https://stackoverflow.com/a/72519463/1654596
export const getFirstDayOfWeek = (locale: Intl.Locale, defaultFirstDayOfWeek: DayIndex = 0): DayIndex => {
  try {
    if (isNewLocaleApi(locale)) {
      return mapDayIndex(locale.getWeekInfo())
    }

    if (isOldLocaleApi(locale)) {
      return mapDayIndex((locale as OldLocaleApi).weekInfo)
    }
  } catch (error) {
    console.error(error)
  }

  return defaultFirstDayOfWeek
}

type DayIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6
const mapDayIndex = (weekInfo: WeekInfo): DayIndex => {
  return (weekInfo.firstDay === 7 ? 0 : weekInfo.firstDay) as DayIndex
}

type WeekInfo = {firstDay: number}
const isWeekInfo = (weekInfo: unknown): weekInfo is WeekInfo => {
  if (!weekInfo) return false
  if (typeof weekInfo !== 'object') return false
  if (!('firstDay' in weekInfo)) return false

  return typeof weekInfo.firstDay === 'number'
}

type OldLocaleApi = Intl.Locale & {weekInfo: WeekInfo}
const isOldLocaleApi = (locale: Intl.Locale): locale is OldLocaleApi => {
  if (!('weekInfo' in locale)) return false

  return isWeekInfo(locale.weekInfo)
}

type NewLocaleApi = Intl.Locale & {getWeekInfo: () => WeekInfo}
const isNewLocaleApi = (locale: Intl.Locale): locale is NewLocaleApi => {
  if (!('getWeekInfo' in locale)) return false
  if (typeof locale.getWeekInfo !== 'function') return false

  return isWeekInfo(locale.getWeekInfo())
}
